export const COMPONENT_TYPE = 'X-Component-Type';


export const SEND_DATA = 'SendData';
export const SEND_FROM_DATA = 'SEND_FROM_DATA';
export const SEND_MODAL_DATA = 'SEND_MODAL_DATA';
export const MODAL = 'ModalManager';
export const CANVAS = '_CanvasManager';
export const PRINT_QR_CODE = 'printQRCode';
export const PRINT_MODAL_DATA = 'PRINT_MODAL_DATA';
export const PRINT_DATA = 'PRINT_DATA';
export const URL = '_url';
export const RELOAD = 'reload';
export const CLOSE = 'close';
export const ELEM_ENABLE = 'elemEnable';
export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_FIELDSET_DATA = 'UPDATE_FIELDSET_DATA';
export const FILE_DOWNLOAD = 'FILE_DOWNLOAD';
export const SAVE_DOM_ELEMENT = 'saveDomElement';
export const EMPTY_VALUE = '___EMPTY_VALUE___';
export const JS = 'JS';
export const POST_FORM = 'POST_FORM';
export const MESSAGE_SUCCESS = 'success';
export const MESSAGE_WARNING = 'warning';
export const MESSAGE_INFO = 'info';
export const MESSAGE_ERROR = 'error';
export const MESSAGE_PRIMARY = 'primary';
export const TAB_MANAGER = 'TabManager';